import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCdMlslZnqn8ceeIX6npzvsjDz_s4zPf9c",
  authDomain: "hot-walk.firebaseapp.com",
  projectId: "hot-walk",
  storageBucket: "hot-walk.firebasestorage.app",
  messagingSenderId: "398675532017",
  appId: "1:398675532017:web:238e4a983a67f4f1ee7150",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
